const TYPE = 'SET_STATE_DEVICE';

const action = ({ id, data }) => (dispatch) => dispatch({ type: TYPE, payload: { id, data } });

export default { action, TYPE };
